<template>
  <teleport v-if="spinning" to="#modals">
    <div class="modal spinner is-active is-layout-fixed">
      <div class="modal-background"></div>
      <div class="modal-content is-clipped has-text-centered">
        <i class="fa fa-spinner fa-spin custom-size" aria-hidden="true"></i>
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  name: 'SpinnerModal',
  props: {
    spinning: Boolean,
  },
  watch: {
    spinning: function (new_val, old_val) {
      if (new_val == false) {
        document.documentElement.style.overflow = 'auto'
      }else{
        document.documentElement.style.overflow = 'hidden'
      }
    },
  },
  created() {
  }
}
</script>

<style scoped>
.is-layout-fixed{
  z-index: 20000;
  position: fixed !important;
}
.custom-size {
    width: 20vw;
    height: 20vh;
}
</style>
